'use client'

import React, { useEffect, useState } from 'react';
import LineStroke from '../individual-components/line-stroke';
import PublicationScroll from './publication-scroll';
import { BlogCard } from '../individual-components/blog-card';
import { getFeaturedCaseStudyListAPI } from '@/api-config/get';
import BlogCardLoader from '../individual-components/loaders/blog-card';

const Publication = ({ context }) => {

    const [loader, setLoader] = useState(true);
    const [featuredCaseStudiesList, setFeaturedCaseStudiesList] = useState(null)

    useEffect(() => {
        getFeaturedCaseStudyListAPI()
            ?.then((res) => {
                setFeaturedCaseStudiesList(res?.data)
                setLoader(false)
            })
            ?.catch((err) => {
                console.log('err:', err)
            })
    }, [])

    // if (!list?.length) {
    //     return;
    // }

    return (
        <section className="relative z-10 flex flex-col justify-center w-full px-4 md:px-8 lg:px-2 max-w-7xl mx-auto md:text-center text-left md:mb-4 mb-28">
            <div className="relative top-[-1.5rem] w-56 xs:w-1/2 mx-auto">
                <LineStroke />
            </div>
            <div className="font-bold text-center md:text-3xl text-4xl leading-none w-full mb-5 md:mx-auto">
                {context?.header}
            </div>
            <div className="text-xl text-secondary text-center md:text-lg md:mb-8 mb-16 w-full md:mx-auto">
                {context?.description}
            </div>
            <div className="grid md:hidden md:grid-cols-1 grid-cols-3 gap-x-6 xl:gap-x-10 gap-y-8 w-full last:mb-0">
                {loader ?
                    [...Array(3)]?.map((_, i) => <BlogCardLoader key={i} />) :

                    (featuredCaseStudiesList || [])?.slice(0, 3)?.map((post) => (
                        <BlogCard key={post?.slug} blogData={post} routelink={"/case-studies"} />
                    ))}
            </div>
            <PublicationScroll posts={featuredCaseStudiesList || []} />
        </section>
    );
};

export default Publication;
